import React, { useContext } from 'react';
import { SearchContext } from '../Contexts';

const CurrentSelection = () => {
  const { facetsLists, setFacetsLists, selectedFacets, setSelectedFacets } =
    useContext(SearchContext);
  const handleRemoveParent = (facetValue, mainIndex, parentIndex) => {
    const facetsClone = [...facetsLists];
    const selectedFacetsClone = { ...selectedFacets };
    // filter only selected ones
    const filteredFacets = facetsClone[mainIndex].facets.filter(
      x => x.selected
    );
    // from selected remove the item with parent index
    filteredFacets[parentIndex].selected = false;

    setFacetsLists(facetsClone);

    selectedFacetsClone[facetsClone[mainIndex].mainValue].splice(
      selectedFacetsClone[facetsClone[mainIndex].mainValue].indexOf(facetValue),
      1
    );

    if (
      facetsClone[mainIndex].facets[parentIndex].childrens &&
      facetsClone[mainIndex].facets[parentIndex].childrens.length
    ) {
      facetsClone[mainIndex].facets[parentIndex].childrens.forEach(child => {
        child.selected = false;
        if (
          selectedFacets[facetsClone[mainIndex].mainValue].includes(child.value)
        ) {
          selectedFacetsClone[facetsClone[mainIndex].mainValue].splice(
            selectedFacetsClone[facetsClone[mainIndex].mainValue].indexOf(
              child.value
            ),
            1
          );
        }
      });
    }
    setSelectedFacets(selectedFacetsClone);
  };

  const handleRemoveChild = (
    facetValue,
    mainIndex,
    parentIndex,
    childIndex
  ) => {
    const facetsClone = [...facetsLists];
    const filteredChilds = facetsClone[mainIndex].facets
      .filter(x => x.selected)
      .map(
        parentSelected =>
          parentSelected.childrens &&
          parentSelected.childrens.filter(x => x.selected)
      );

    filteredChilds[parentIndex][childIndex].selected = false;

    setFacetsLists(facetsClone);

    const selectedFacetsClone = { ...selectedFacets };
    selectedFacetsClone[facetsClone[mainIndex].mainValue].splice(
      selectedFacetsClone[facetsClone[mainIndex].mainValue].indexOf(facetValue),
      1
    );
    setSelectedFacets(selectedFacetsClone);
  };

  return facetsLists && facetsLists.length ? (
    <div className="advanced-search__current-selection">
      {facetsLists.map((dropdown, j) =>
        dropdown.facets
          .filter(x => x.selected)
          .map((parentFacet, i) => (
            <div
              className="advanced-search__current-selection__item-selected"
              key={i}
            >
              {parentFacet.label}
              <button
                type="button"
                className="advanced-search__current-selection__close-btn"
                onClick={() => handleRemoveParent(parentFacet.value, j, i)}
              >
                X
              </button>
            </div>
          ))
      )}

      {facetsLists.map((dropdown, j) =>
        dropdown.facets
          .filter(x => x.selected)
          .map(
            (parentSelected, index) =>
              parentSelected.childrens &&
              parentSelected.childrens
                .filter(x => x.selected)
                .map((childFacets, i) => (
                  <div
                    className="advanced-search__current-selection__item-selected"
                    key={i}
                  >
                    {childFacets.label}
                    <button
                      type="button"
                      className="advanced-search__current-selection__close-btn"
                      onClick={() =>
                        handleRemoveChild(childFacets.value, j, index, i)
                      }
                    >
                      X
                    </button>
                  </div>
                ))
          )
      )}
    </div>
  ) : (
    ''
  );
};

export default CurrentSelection;
